import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
// import RangeInput from "../elements/RangeInput"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)

    return (
        <details class={`${facet.name === 'Price' ? 'ns-price-slider' : '' } js-filter border-b border-t-ui-lines-2 px-sm group/filter-dropdown`} aria-labelledby={`facet-heading-${facet.id}`}>
            <summary class="ns-facet-heading focus-inset flow-root py-lg md:py-md cursor-pointer">
                <div class="flex w-full items-center justify-between">
                    <h6 id={`facet-heading-${facet.id}`} class="caption-large uppercase">
                        {facet.name}
                    </h6>
                    <svg fill="none" class="icon icon-plus" viewBox="0 0 10 10" aria-label="Plus icon" role="presentation"  focusable="false">
                        <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path>
                    </svg>
                    <svg fill="none" class="icon icon-minus" id="icon-minus" viewBox="0 0 10 2" aria-label="Minus icon" role="presentation" focusable="false">
                        <path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path>
                    </svg>
                </div>
            </summary>

            <div class="pb-6">
                <RangeSlider id={facet.id} />
                <div class="mb-1.5 flex items-center justify-between">
                    <span className="caption text-t-foreground">
                        {facet.name === 'Price' ? "$" : ""}{range[0]}
                    </span>
                    <span className="caption text-t-foreground">
                        {facet.name === 'Price' ? "$" : ""}{range[1]}
                    </span>
                </div>
                {/* <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div> */}
            </div>
        </details>
    )
}
